import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=b6290448&"
import script from "./points.js?vue&type=script&lang=js&"
export * from "./points.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports